import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Team from "./pages/Team";
import Research from "./pages/Research";
import Education from "./pages/Education";
import Contact from "./pages/Contact";
import FVDAMDemo from "./pages/FVDAMDemo";
import AboutUS from "./pages/AboutUs";
import './styles/Layout.css';
import Login from "./pages/Login";
  
function App() {
  return (
    <Router  basename="/">
      <div className="layout">
      <Navbar/>
      <Routes>
        <Route path="/aboutus" element={<AboutUS />} />
        <Route path="/demos/fvdam" element={<FVDAMDemo />} />
        <Route path="/" element={<Home />} />
        <Route path="/team" element={<Team />} />
        <Route path="/research" element={<Research />} />
        <Route path="/education" element={<Education />} />
        <Route path="/contact" element={<Contact />} />
        {/* <Route path="/login" element={<Login />} /> */}

      </Routes>
      <Footer />
      </div>
    </Router>
  );
}

export default App;
